export function test(key, fn) {
  if (!this.getUserSettings('debuggingMode')) return

  this.groupLog('Test results: ' + key)
  try {
    const exec = fn()
    if (!exec) {
      this.error('%c' + key + ' failed: Did not pass', fn)
      window.requestAnimationFrame(() => {
        this.call('openNotification', {
          title: key,
          message: this.call('polyglot', 'editor.test.didNotPass'),
          type: 'error'
        })
      })
      this.groupLogEnd('Test results: ' + key)
      return
    }
    this.log('%cTesting ' + key + ' passed!', 'color: green; font-weight: bold')
    this.groupLogEnd('Test results: ' + key)
    return exec
  } catch (e) {
    this.error(key + ' failed:')
    this.error(e)
    window.requestAnimationFrame(() => {
      this.call('openNotification', {
        title: this.call('polyglot', 'editor.test.failed').replace('{key}', key),
        message: e,
        type: 'error'
      })
    })
    this.groupLogEnd('Test results: ' + key)
  }
}

export function testAll(key, fn) {
  return this.test(key, async () => {
    const arr = await this.call('exec', fn)
    if (!Array.isArray(arr)) {
      this.error('Test array is not an array')
      return false
    }
    if (arr.length === 0) {
      this.error('Test array is empty')
      return false
    }
    return arr.filter((v) => v !== undefined).every((item) => item)
  })
}

export function testIf(condition, key, fn) {
  if (condition) {
    return this.test(key, fn)
  }
}

export function isEqual(one, second, opts = {}) {
  this.log('%cChecking equality', 'color: gray')

  const isEqual = one === second

  if (!isEqual && !opts.skipLogging) {
    this.error('Is not equal:')
    this.log(one)
    this.log(second)
  }

  return isEqual
}

export function isEqualFunction(one, second, opts = {}) {
  this.log('%cChecking equality of functions', 'color: gray')

  const stringifiedOne = one.toString()
  const stringifiedTwo = second.toString()

  const isEqual = this.isEqual(stringifiedOne, stringifiedTwo)

  if (!isEqual && !opts.skipLogging) {
    this.error('Is not equal:')
    this.log(one)
    this.log(second)
  }

  return isEqual
}

export function isEqualObject(one, second, opts = {}) {
  this.log('%cChecking equality of objects', 'color: gray')

  const diff =
    (this.call('isObjectLike', one) &&
      this.call('isObjectLike', second) &&
      this.call('diff', one, second, void 0, { cloneInstances: true })) ||
    null
  const isEqual = one && second && this.call('isObjectLike', diff) && Object.keys(diff).length === 0

  if (!isEqual && !opts.skipLogging) {
    this.error('Is not equal:')
    this.log(one)
    this.log(second)
    this.log('With diff:')
    this.log(diff)
  }

  return isEqual
}

export function exists(value) {
  this.log('%cChecking value existence', 'color: gray')

  if (value === undefined) {
    this.error('Does not exist')
    return false
  }

  return true
}

export function existsIf(condition, value) {
  this.log('%cChecking value existence if condition applies', 'color: gray')

  if (condition && value === undefined) {
    this.error('Does not exist')
    return false
  }

  return true
}

export function notExists(value) {
  this.log('%cChecking value non-existence', 'color: gray')

  if (value) {
    this.error('Exists')
    return false
  }

  return true
}

export function notExistsIf(condition, value) {
  this.log('%cChecking value non-existence', 'color: gray')

  if (condition && value !== undefined) {
    this.error('Exists')
    return false
  }

  return true
}

export function testCase(descr, func, ...params) {
  this.groupLog(descr)
  const res = this.call(func, ...params)
  if (res) this.log('%cPassed', 'color: green')
  else this.error('%cFailed: ' + descr, 'color: red')
  this.groupLogEnd(descr)
  return res
}
